export enum DashboardOCWPermissions {
    MboVsvDashboard = 'mbo-vsv-dashboard',
}
